module.exports = __webpack_public_path__ + "media/images/850/sleep_apnea_get_good_sleep-32e889c930355275ca23d7849b6578b1.webp";